export default function* rootSaga() {
  yield []; // for now it's empty. Will add some later if necessary.
}
